module.exports = __webpack_public_path__ + "static/media/heart_red.bd12165b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/heart_red.svg
// module id = 178
// module chunks = 0